import { Eyebrow, Heading } from "./Section";

const STATS = [
  { value: "7+", label: "Years Experience" },
  { value: "2019", label: "Established" },
  { value: "Wed–Sat", label: "Open Days" },
];

export const About = () => (
  <section id="about" data-testid="about" className="py-20 md:py-28 bg-charcoal">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
      <Eyebrow>The Barber</Eyebrow>
      <Heading className="mx-auto">MEET AAHEEKA</Heading>
      <p className="mt-6 text-lg md:text-xl text-cream/75 font-body leading-relaxed max-w-2xl mx-auto">
        Since 2019, AK Cuts has been Pakenham's go-to for clean fades, sharp beard lines, and cuts that actually last the week.
      </p>

      <div className="mt-12 grid grid-cols-3 gap-4 md:gap-8">
        {STATS.map((s) => (
          <div key={s.label} data-testid={`stat-${s.label}`} className="border-t-2 border-barber-red pt-4">
            <div className="font-display text-4xl md:text-6xl text-cream leading-none">{s.value}</div>
            <div className="mt-2 font-mono-u text-[10px] md:text-xs tracking-widest uppercase text-cream/60">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
